// @ts-nocheck

export default {
  "l10n": {
    "currency": '\u20ac',
    "date": {
      "months": {
        "full": ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],
        "abbr": ["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc."]
      },
      "days": {
        "full": ["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],
        "abbr": ["dim.","lun.","mar.","mer.","jeu.","ven.","sam."]
      },
      "patterns": {
        "longDate": "dddd D MMMM YYYY",
        "dateSlash": "DD/MM/YYYY",
        "dateShort": "dddd D MMMM",
        "dateShortWithDay": "Do MMMM YYYY",
        "dateMedium": "dddd D MMMM - H[h]mm",
        "dateMediumReversed" : "H[h]mm - D MMMM YYYY",
        "dateMediumSlash": "DD[/]MM[/]YYYY [à] H[h]mm",
        "dateLarge": "D MMM YYYY [à] HH[:]mm",
        "timeShort": "LT",
        "timeMedium": "DD[/]MM [•] LT",
        "timeLarge": "DD[/]MM[/]YY [•] LT"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-n S", "n S"]
      },
      "group": {
        "separator": " ",
        "length": 3,
        "abbr": ["", "k", "M", "Md"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "ordinal": function (number) { return number + (number === 1 ? 'er' : 'e'); }
    }
  },
  "translations": {
    messages: {
  "!action:Bet": [
    null,
    "Parier"
  ],
  "!action:GiftRace Start": [
    null,
    "Commencer"
  ],
  "!action:Settings": [
    null,
    "Paramétrer"
  ],
  "!action:Share": [
    null,
    "Partager"
  ],
  "!action:deleteAndContinue": [
    null,
    "Effacer et continuer"
  ],
  "!action:viewMyNonValidatedBets": [
    null,
    "Voir mes paris non validés"
  ],
  "!desc:%1$s ES RM J-30 warning": [
    null,
    ""
  ],
  "!desc:ArjelAdvice": [
    null,
    "Toute personne peut demander à être interdite de jeux. Cette demande est formée auprès de l'Autorité nationale des jeux. Cette interdiction est applicable dans les casinos, dans les clubs de jeux, sur les sites de jeux et de paris en ligne exploités par les opérateurs de jeux agréés en France, sur le site de jeux de loterie en ligne exploité par La Française des jeux ainsi que sur les bornes de jeux accessibles avec un compte joueur exploitées par les opérateurs titulaires de droits exclusifs, notamment La Française des jeux et le Pari mutuel urbain. Cette interdiction est prononcée pour une durée qui ne peut être inférieure à trois ans. Elle est renouvelable tacitement."
  ],
  "!desc:ArjelLink": [
    null,
    "Interdiction volontaire de jeu"
  ],
  "!desc:ArjelTitle": [
    null,
    "Winamax est agréé par l'Autorité Nationale des Jeux"
  ],
  "!desc:BROptaWidgetWarning": [
    null,
    "Les résultats des paris relatifs aux tirs sont basés sur les statistiques officielles de l'organisateur, et non les statistiques affichées ci-dessus."
  ],
  "!desc:BasketHowTo": [
    null,
    "Ajoute tes paris en cliquant sur les cotes"
  ],
  "!desc:BetBuilderHelper": [
    null,
    "Avec MyMatch, crée ton pari en choisissant plusieurs sélections sur un même match et obtiens ta cote personnalisée."
  ],
  "!desc:BetBuilderHelperBasketball": [
    null,
    "Avec MyMatch, créez votre pari en choisissant plusieurs sélections sur un même match (vainqueur du match, nombre de points/rebonds/passes décisives d'un joueur) et obtenez votre cote personnalisée."
  ],
  "!desc:BetBuilderHelperSoccer": [
    null,
    "Avec MyMatch, créez votre pari en choisissant plusieurs sélections sur un même match (résultat à la mi-temps, score exact final, nombre de buts, buteurs, ...) et obtenez votre cote personnalisée."
  ],
  "!desc:BetshareWebsite": [
    null,
    "winamax.fr"
  ],
  "!desc:BzgaLegals": [
    null,
    "Eigentümer und Betreiber - Winamax SA - 136 B Rue de Grenelle, 75007 Paris, Frankreich\nGlücksspiel kann süchtig machen. Hilfe unter"
  ],
  "!desc:CashoutPendingRegulation": [
    null,
    "The Cashout amount is only paid out when all selections of the bet have been settled"
  ],
  "!desc:ClientUpdaterContent": [
    null,
    "Pour mettre à jour l’application, désinstallez la version actuelle puis téléchargez la nouvelle application directement depuis l’App Store."
  ],
  "!desc:ClientUpdaterContentDeprecated": [
    null,
    "Cette version de l’application ne comporte pas les dernières améliorations et sera bientôt bloquée."
  ],
  "!desc:DEBetTaxFreeDescription": [
    null,
    ""
  ],
  "!desc:DVTMLink": [
    null,
    "Verantwortliches Spiel"
  ],
  "!desc:DgojConfidentiality": [
    null,
    "Política de privacidad"
  ],
  "!desc:DgojLicence": [
    null,
    "\n        WINAMAX Sociedad Anónima (S.A.) cuya sede social se encuentra en 136bis Rue de Grenelle, 75007 París France.\n        Todos los derechos reservados.\n\n        WINAMAX se responsabiliza de este sitio web, al que la Dirección General de Ordenación del Juego le ha concedido las siguientes licencias: POQUER No/Ref: POQ/2018/001, APUESTAS DEPORTIVAS DE CONTRAPARTIDA No/Ref: ADC/2018/017\n\n        Está prohibida la participación de los menores de edad y los incapacitados legalmente o por resolución judicial.\n      "
  ],
  "!desc:DgojResponsibleGaming": [
    null,
    "Juego responsable"
  ],
  "!desc:DgojResponsibleGamingTextES": [
    null,
    "Il s'agit d'une application de jeux d'argent et de hasard avec de l'argent réel. Veuillez jouer de manière responsable et ne miser que ce que vous pouvez vous permettre. Pour obtenir de l'aide et du soutien en matière de dépendance au jeu, veuillez communiquer avec Fejar au 900 533 025 ou consulter le https://fejar.org/ "
  ],
  "!desc:DgojTerms": [
    null,
    "Términos y condiciones"
  ],
  "!desc:DocumentTitle": [
    null,
    "Paris sportifs | Winamax paris sportifs | Paris en ligne"
  ],
  "!desc:DocumentTitleLive": [
    null,
    "Pari en direct - Parie sur le Sport en direct sur Winamax"
  ],
  "!desc:FreebetHelper": [
    null,
    "Les Freebets sont offerts dans le cadre d'offres promotionnelles.\nEn cas de pari gagnant, seuls les gains nets (gains - mise) seront crédités sur ton compte."
  ],
  "!desc:GoalScorersHelper": [
    null,
    "Pariez sur un(e) joueur(se) qui marquera au moins un but ou alors précisément le premier ou dernier buteur dans le match. Ces paris sont hors prolongations et tirs au but éventuels. Les buts contre son camp ne sont pas comptabilisés. Si le premier (respectivement dernier) but du match est un but marqué contre son camp, le joueur marquant le but suivant (respectivement l'avant-dernier but) sera considéré comme le premier buteur (respectivement dernier buteur) du match."
  ],
  "!desc:Minus18DE": [
    null,
    "Minderjährigen ist die Benutzung verboten"
  ],
  "!desc:MonopolyEnrollmentMessage": [
    null,
    "Complète tes collections Monopoly grâce à tes paris et gagne des Freebets !"
  ],
  "!desc:PanicButtonConfirmation": [
    null,
    "You have activated a 24h break across all providers. You can play again earliest on tomorrow at %1$s."
  ],
  "!desc:PanicButtonConfirmationTitle": [
    null,
    "Your account is on a break"
  ],
  "!desc:RealityCheckMessage": [
    null,
    "N'oubliez pas de faire des pauses régulières. Vous pouvez également trouver de plus amples informations dans la section « Protection des joueurs »."
  ],
  "!desc:ResponsibleGamingTextFR": [
    null,
    "Il s'agit d'une application de jeux d'argent et de hasard avec de l'argent réel. Veuillez jouer de manière responsable et ne miser que ce que vous pouvez vous permettre. Pour obtenir de l'aide et du soutien en matière de dépendance au jeu, veuillez communiquer avec joueurs-info-service au 09-74-75-13-13 ou consulter le site http://www.joueurs-info-service.fr/"
  ],
  "!desc:SoccerDecisivePlayer": [
    null,
    "Concernant les 2 paris \"joueur décisif\" et \"passe décisive\", les paris seront annulés si le joueur concerné ne joue pas. Par ailleurs, le résultat des paris est basé selon les statistiques Opta.\nLe joueur sera décisif dans le match, c'est à dire qu'il marquera au moins un but ou qu'il fera au moins une passe décisive (hors prolongations et TAB)."
  ],
  "!desc:SoccerScorerDuo": [
    null,
    "Pariez sur le nombre de buts marqués par les deux joueurs au cours du match (hors prolongations et tirs au but éventuels). Le pari sera remboursé si l'un des joueurs n'a pas joué."
  ],
  "!desc:SoccerScorerTrio": [
    null,
    "Pariez sur le nombre de buts marqués par les trois joueurs au cours du match (hors prolongations et tirs au but éventuels). Le pari sera remboursé si l'un des joueurs n'a pas joué."
  ],
  "!desc:SrijLicence": [
    null,
    "WINAMAX, S.A. Todos os direitos reservados. É uma empresa registada em Portugal com o número de empresa XXXXXXXXX, com sede na XXXXXXXX, em XXXXX e é titular das licenças de jogo n° XXX e XXX emitidas pelo SRIJ – Serviço de Regulação e Inspeção de Jogos que a autoriza a desenvolver a atividade de exploração de apostas desportivas à cota e de jogos de fortuna ou azar online em Portugal."
  ],
  "!desc:activateLineUpNotifications": [
    null,
    "Tu veux recevoir une notif mobile lorsque les compos tombent sur tes matchs en favori ? \nActive tes notifs depuis tes préférences de communication"
  ],
  "!desc:userAlreadyOptedIn": [
    null,
    "Vous participez déjà à cette opération."
  ],
  "!noun:GridsCancelled": [
    null,
    "Annulée"
  ],
  "!noun:GridsFilterCancelled": [
    null,
    "Annulées"
  ],
  "!noun:GridsFilterLost": [
    null,
    "Perdues"
  ],
  "!noun:GridsFilterRunning": [
    null,
    "En cours"
  ],
  "!noun:GridsFilterWon": [
    null,
    "Gagnées"
  ],
  "!noun:GridsFinancing": [
    null,
    "En cours de financement"
  ],
  "!noun:GridsFinished": [
    null,
    "Terminée"
  ],
  "!noun:GridsLost": [
    null,
    "Perdue"
  ],
  "!noun:GridsNotValidated": [
    null,
    "non validée"
  ],
  "!noun:GridsRunning": [
    null,
    "En cours"
  ],
  "!noun:GridsWon": [
    null,
    "Gagnée"
  ],
  "!noun:MonopolyWon": [
    "!noun:MonopolyWonPlural",
    "Remportée :",
    "Remportées :"
  ],
  "!noun:Rules": [
    null,
    "Règles"
  ],
  "!noun:Welcome": [
    null,
    "Bienvenue"
  ],
  "!noun:Won": [
    null,
    "Gagné"
  ],
  "!plural:Finished": [
    null,
    "Terminés"
  ],
  "!plural:Won": [
    null,
    "Gagnés"
  ],
  "!scorer:Next": [
    null,
    "Prochain"
  ],
  "!short:1st half - 2 or more": [
    null,
    "Mi-temps - Doublé"
  ],
  "!short:1st half - 3 or more": [
    null,
    "Mi-temps - Triplé"
  ],
  "!short:1st half - 4 or more": [
    null,
    "Mi-temps - Quadruplé"
  ],
  "!short:1st period - Scorer": [
    null,
    "1er tiers-temps - Buteur"
  ],
  "!short:2 or more": [
    null,
    "Doublé"
  ],
  "!short:2nd half - 2 or more": [
    null,
    "2de mi-temps - Doublé"
  ],
  "!short:2nd half - 3 or more": [
    null,
    "2de mi-temps - Triplé"
  ],
  "!short:2nd half - 4 or more": [
    null,
    "2de mi-temps - Quadruplé"
  ],
  "!short:2nd period - Scorer": [
    null,
    "2e tiers-temps - Buteur"
  ],
  "!short:3 or more": [
    null,
    "Triplé"
  ],
  "!short:3rd period - Scorer": [
    null,
    "3e tiers-temps - Buteur"
  ],
  "!short:4 or more": [
    null,
    "Quadruplé"
  ],
  "!short:AdditionnalTime": [
    null,
    "MS"
  ],
  "!short:Anytime goalscorer": [
    null,
    "Buteur"
  ],
  "!short:BothHalf": [
    null,
    "Les deux"
  ],
  "!short:Double": [
    null,
    "Doublé"
  ],
  "!short:Draw": [
    null,
    "N"
  ],
  "!short:First": [
    null,
    "Premier"
  ],
  "!short:FirstHalf": [
    null,
    "1re"
  ],
  "!short:HalfTime": [
    null,
    "MT"
  ],
  "!short:Hat-trick": [
    null,
    "Triplé"
  ],
  "!short:Last": [
    null,
    "Dernier"
  ],
  "!short:Next": [
    null,
    "Prochain"
  ],
  "!short:Overtime": [
    null,
    "P"
  ],
  "!short:Overtime - 2 or more": [
    null,
    "Prolongations - Doublé"
  ],
  "!short:PenaltyShootOut": [
    null,
    "TAB"
  ],
  "!short:Points": [
    null,
    "PTS"
  ],
  "!short:RegularTime": [
    null,
    "Tps Régl."
  ],
  "!short:ScorerConversion": [
    null,
    "T"
  ],
  "!short:ScorerDrop": [
    null,
    "D"
  ],
  "!short:ScorerPenalty": [
    null,
    "P"
  ],
  "!short:SecondHalf": [
    null,
    "2de"
  ],
  "!short:Today": [
    null,
    "Auj."
  ],
  "!short:bet": [
    "!short:bets",
    "pari",
    "paris"
  ],
  "%1$s (multiple chance)": [
    null,
    "%1$s multichance"
  ],
  "%1$s + %2$s": [
    null,
    "%1$s + %2$s"
  ],
  "%1$s Base": [
    "%1$s Bases",
    "%1$s Base",
    "%1$s Bases"
  ],
  "%1$s bet": [
    "%1$s bets",
    "%1$s pari",
    "%1$s paris"
  ],
  "%1$s bet added": [
    "%1$s bets added",
    "%1$s pari ajouté",
    "%1$s paris ajoutés"
  ],
  "%1$s bet could not be validated": [
    "%1$s bets could not be validated",
    "%1$s pari n'a pas pu être validé",
    "%1$s paris n'ont pas pu être validés"
  ],
  "%1$s bet selected": [
    "%1$s bets selected",
    "%1$s pari sélectionné",
    "%1$s paris sélectionnés"
  ],
  "%1$s guarenteed ": [
    null,
    "%1$s garantis"
  ],
  "%1$s or more": [
    null,
    "%1$s ou plus"
  ],
  "%1$s selection": [
    "%1$s selections",
    "%1$s pronostic",
    "%1$s pronostics"
  ],
  "%1$s selection could not be added": [
    "%1$s selections could not be added",
    "%1$s sélection n'a pas pu être ajoutée",
    "%1$s sélections n'ont pas pu être ajoutées"
  ],
  "%1$s single bet": [
    "%1$s single bets",
    "%1$s pari simple",
    "%1$s paris simples"
  ],
  "%1$s's bet": [
    null,
    "Pari de %1$s"
  ],
  "%1$s-%2$s PSO": [
    null,
    "TAB %1$s-%2$s"
  ],
  "%1$s-%2$s a.e.t.": [
    null,
    "%1$s-%2$s a.p."
  ],
  "%1$s-%2$s reg. time": [
    null,
    "reg %1$s-%2$s"
  ],
  "%1$s:": [
    null,
    "%1$s :"
  ],
  "(1 to %1$s)": [
    null,
    "(1 à %1$s)"
  ],
  "+%1$s min": [
    null,
    "+%1$s min"
  ],
  "10th set": [
    null,
    "10e set"
  ],
  "12-grids": [
    null,
    "Grilles 12"
  ],
  "1st": [
    null,
    "1er"
  ],
  "1st half": [
    null,
    "1re mi-temps"
  ],
  "1st innings": [
    null,
    "1re manche"
  ],
  "1st period": [
    null,
    "1re période"
  ],
  "1st quarter": [
    null,
    "1er quart-temps"
  ],
  "1st set": [
    null,
    "1er set"
  ],
  "2 or more": [
    null,
    "Doublé"
  ],
  "24-hour break": [
    null,
    "24-hour break"
  ],
  "2nd": [
    null,
    "2ème"
  ],
  "2nd half": [
    null,
    "2de mi-temps"
  ],
  "2nd half - Multiple goalscorers": [
    null,
    "2de mi-temps - Buteurs multiples"
  ],
  "2nd innings": [
    null,
    "2e manche"
  ],
  "2nd period": [
    null,
    "2e période"
  ],
  "2nd quarter": [
    null,
    "2e quart-temps"
  ],
  "2nd set": [
    null,
    "2e set"
  ],
  "3 or more": [
    null,
    "Triplé"
  ],
  "3rd": [
    null,
    "3ème"
  ],
  "3rd innings": [
    null,
    "3e manche"
  ],
  "3rd period": [
    null,
    "3e période"
  ],
  "3rd quarter": [
    null,
    "3e quart-temps"
  ],
  "3rd set": [
    null,
    "3e set"
  ],
  "4 or more": [
    null,
    "Quadruplé"
  ],
  "4th innings": [
    null,
    "4e manche"
  ],
  "4th quarter": [
    null,
    "4e quart-temps"
  ],
  "4th set": [
    null,
    "4e set"
  ],
  "5th innings": [
    null,
    "5e manche"
  ],
  "5th set": [
    null,
    "5e set"
  ],
  "6th innings": [
    null,
    "6e manche"
  ],
  "6th set": [
    null,
    "6e set"
  ],
  "7-grids": [
    null,
    "Grilles 7"
  ],
  "7th innings": [
    null,
    "7e manche"
  ],
  "7th set": [
    null,
    "7e set"
  ],
  "8th innings": [
    null,
    "8e manche"
  ],
  "8th set": [
    null,
    "8e set"
  ],
  "9th innings": [
    null,
    "9e manche"
  ],
  "9th set": [
    null,
    "9e set"
  ],
  "A server issue has interrupted media playback.": [
    null,
    "Un problème réseau a interrompu la lecture de la vidéo."
  ],
  "ALL-IN": [
    null,
    "ALL-IN"
  ],
  "Accept changes": [
    null,
    "Accepter les changements"
  ],
  "Acces to media failed.": [
    null,
    "L'accès au média a échoué."
  ],
  "Accumulator": [
    null,
    "Combiné"
  ],
  "Accumulator %1$s": [
    null,
    "Combiné %1$s"
  ],
  "Add": [
    null,
    "Ajouter"
  ],
  "Add an In-Play selection to get a %1$s bonus": [
    null,
    "Ajoute une sélection live pour obtenir un bonus de %1$s"
  ],
  "Add bet to basket": [
    null,
    "Ajouter le pari dans mon panier"
  ],
  "Add one selection to get a %1$s bonus": [
    null,
    "Ajoute une sélection pour obtenir un bonus de %1$s"
  ],
  "Additional buttons allow you to make variations of an existing grid.": [
    null,
    "Des boutons supplémentaires te permettent de faire des variations autour d'une grille existante."
  ],
  "Ajax Amsterdam": [
    null,
    "Ajax Amsterdam"
  ],
  "All": [
    null,
    "Tous"
  ],
  "All my grids": [
    null,
    "Toutes mes grilles"
  ],
  "All players": [
    null,
    "Tous les joueurs"
  ],
  "All possible accumulators %1$s with %2$s from %3$s others, or %4$s in total": [
    null,
    "Tous les combinés possibles %1$s avec %2$s parmi les %3$s autres, soit %4$s paris au total"
  ],
  "All possible accumulators from the %1$s from amongst %2$s, or %3$s in total": [
    null,
    "Tous les combinés possibles de %1$s parmi les %2$s, soit %3$s paris au total"
  ],
  "All rules": [
    null,
    "Toutes les règles"
  ],
  "Amount": [
    null,
    "Montant"
  ],
  "Amount collected:": [
    null,
    "Montant collecté :"
  ],
  "Amount shared out:": [
    null,
    "Montant distribué :"
  ],
  "Amount to be carried forward:": [
    null,
    "Montant à reporter :"
  ],
  "An error as occurred.": [
    null,
    "Une erreur s'est produite."
  ],
  "An error has occured": [
    null,
    "Une erreur s'est produite."
  ],
  "An error occurred, please try again.": [
    null,
    "Une erreur est survenue, merci de réessayer."
  ],
  "And remember,": [
    null,
    "Et rappelle-toi,"
  ],
  "And you will unlock phase 2.": [
    null,
    "Et tu débloqueras la phase 2."
  ],
  "And you will unlock phase 3.": [
    null,
    "Et tu débloqueras la phase 3."
  ],
  "Anytime": [
    null,
    "Buteur"
  ],
  "Assistman": [
    null,
    "Passeur"
  ],
  "Assists": [
    null,
    "Passes"
  ],
  "Assists+rebounds": [
    null,
    "Passes+rebonds"
  ],
  "At least one of the two teams": [
    null,
    "Au moins une des deux équipes"
  ],
  "At least one of your multi-chance selections has too many choices.": [
    null,
    "Au moins une de tes sélections multichance comporte trop de choix."
  ],
  "At least one of your selections is currently suspended": [
    null,
    "Au moins une de tes sélections est actuellement suspendue."
  ],
  "At least one of your selections is no longer available.": [
    null,
    "Au moins une de tes sélections n'est plus disponible."
  ],
  "At least one of your selections is no longer available. Check your betslip.": [
    null,
    "Au moins une de tes sélections n'est plus disponible. Vérifie ton panier."
  ],
  "At least one of your selections is not eligible for MyMatch.": [
    null,
    "Au moins une de tes sélections n'est pas éligible au MyMatch."
  ],
  "At least one of your selections is not eligible for MyMatch. Check your betslip.": [
    null,
    "Au moins une de tes sélections n'est pas éligible au MyMatch. Vérifie ton panier."
  ],
  "Atletico Madrid": [
    null,
    "Atletico Madrid"
  ],
  "Author": [
    null,
    "Auteur"
  ],
  "BOOM, easy game!": [
    null,
    "BOOM, facile ce jeu !"
  ],
  "Back": [
    null,
    "Retour"
  ],
  "Back to grid creation": [
    null,
    "Retour à la création de la grille"
  ],
  "Back to sports betting": [
    null,
    "Retour aux paris sportifs"
  ],
  "Back to the grid of the day": [
    null,
    "Retour à la grille du jour"
  ],
  "Balance": [
    null,
    "Solde"
  ],
  "Base": [
    null,
    "Base"
  ],
  "Bayern Munich": [
    null,
    "Bayern Munich"
  ],
  "Best author (badge)": [
    null,
    "Meilleur auteur (badge)"
  ],
  "Best author (winnings)": [
    null,
    "Meilleur auteur (gains)"
  ],
  "Best bets": [
    null,
    "Les meilleurs paris"
  ],
  "Bet": [
    null,
    "Pari"
  ],
  "Bet %1$s could not be redeemed, one or more selections are not eligible for Cashout": [
    null,
    "Le pari %1$s n'a pas pu être racheté, une ou plusieurs sélections ne sont pas éligibles au cashout"
  ],
  "Bet %1$s could not be redeemed, remaining bet is less than €0.10": [
    null,
    "Le pari %1$s n'a pas pu être racheté, la mise restante est inférieure à 0,10€"
  ],
  "Bet %1$s could not be redeemed, the Cashout amount has changed": [
    null,
    "Le pari %1$s n'a pas pu être racheté, le montant du cashout a changé"
  ],
  "Bet confirmation": [
    null,
    "Confirmation de pari"
  ],
  "Bet is limited to free bet": [
    null,
    "Pari disponible uniquement avec un pari gratuit"
  ],
  "Bet is not eligible for Boom %1$s": [
    null,
    "Le pari n'est pas éligible à Boom %1$s"
  ],
  "Bet is not eligible for Boom %1$s because at least one match starts after the end of the game": [
    null,
    "Le pari n'est pas éligible à Boom %1$s car au moins un match débute après la fin du jeu"
  ],
  "Bet is not eligible for Boom %1$s because system bets are not eligible": [
    null,
    "Le pari n'est pas éligible à Boom %1$s car les paris système ne sont pas éligibles"
  ],
  "Bet is not eligible for Boom %1$s because the game is not in progress": [
    null,
    "Le pari n'est pas éligible à Boom %1$s car le jeu n'est pas en cours"
  ],
  "Bet is not eligible for Boom %1$s because the match starts in over 48 hours": [
    null,
    "Le pari n'est pas éligible à Boom %1$s car le match démarre dans plus de 48h"
  ],
  "Bet is not eligible for Boom %1$s because you have a bet in the validation process": [
    null,
    "Le pari n'est pas éligible à Boom %1$s car tu as un pari en cours de validation"
  ],
  "Bet is not eligible for Boom %1$s because you have already placed an eligible bet on the same match": [
    null,
    "Le pari n'est pas éligible à Boom %1$s car tu as déjà placé un pari éligible sur le même match"
  ],
  "Bet is not eligible for Boom %1$s because you have not started the game": [
    null,
    "Le pari n'est pas éligible à Boom %1$s car tu n'as pas commencé le jeu"
  ],
  "Bet is not eligible for Monopoly": [
    null,
    "Le pari n'est pas éligible à Monopoly"
  ],
  "Bet is not eligible for Monopoly because at least one match starts after the end of the game": [
    null,
    "Le pari n'est pas éligible à Monopoly car au moins un match débute après la fin du jeu"
  ],
  "Bet is not eligible for Monopoly because system bets are not eligible": [
    null,
    "Le pari n'est pas éligible à Monopoly car les paris système ne sont pas éligibles"
  ],
  "Bet is not eligible for Monopoly because the game is not in progress": [
    null,
    "Le pari n'est pas éligible à Monopoly car le jeu n'est pas en cours"
  ],
  "Bet is not eligible for Monopoly because the match starts in over 48 hours": [
    null,
    "Le pari n'est pas éligible à Monopoly car le match démarre dans plus de 48h"
  ],
  "Bet is not eligible for Monopoly because you have already placed an eligible bet on the same match": [
    null,
    "Le pari n'est pas éligible à Monopoly car tu as déjà placé un pari éligible sur le même match"
  ],
  "Bet is not eligible for Monopoly because you have not started the game": [
    null,
    "Le pari n'est pas éligible à Monopoly car tu n'as pas commencé le jeu"
  ],
  "Bet is not eligible for the Gift Race": [
    null,
    "Le pari n'est pas éligible à La Course aux Cadeaux"
  ],
  "Bet is not eligible for the Gift Race because at least one match starts after the end of the game": [
    null,
    "Le pari n'est pas éligible à La Course aux Cadeaux car au moins un match débute après la fin du jeu"
  ],
  "Bet is not eligible for the Gift Race because system bets are not eligible": [
    null,
    "Le pari n'est pas éligible à La Course aux Cadeaux car les paris système ne sont pas éligibles"
  ],
  "Bet is not eligible for the Gift Race because the game is not in progress": [
    null,
    "Le pari n'est pas éligible à La Course aux Cadeaux car le jeu n'est pas en cours"
  ],
  "Bet is not eligible for the Gift Race because the match starts in over 48 hours": [
    null,
    "Le pari n'est pas éligible à La Course aux Cadeaux car le match démarre dans plus de 48h"
  ],
  "Bet is not eligible for the Gift Race because this version of the game has ended": [
    null,
    "Le pari n'est pas éligible à La Course aux Cadeaux car cette version du jeu est terminé"
  ],
  "Bet is not eligible for the Gift Race because you have a reward to collect in order to unlock the next gift": [
    null,
    "Le pari n'est pas éligible à La Course aux Cadeaux car tu as une récompense à récupérer pour débloquer le prochain cadeau"
  ],
  "Bet is not eligible for the Gift Race because you have already placed an eligible bet on the same match": [
    null,
    "Le pari n'est pas éligible à La Course aux Cadeaux car tu as déjà placé un pari éligible sur le même match"
  ],
  "Bet is not eligible for the Gift Race because you have already won the gift": [
    null,
    "Le pari n'est pas éligible à La Course aux Cadeaux car tu as déjà remporté le cadeau"
  ],
  "Bet is not eligible for the Gift Race because you have not started the game": [
    null,
    "Le pari n'est pas éligible à La Course aux Cadeaux car tu n'as pas commencé le jeu"
  ],
  "Bet is not eligible for the Gift Race because you must start the gift quest again": [
    null,
    "Le pari n'est pas éligible à La Course aux Cadeaux car tu dois d'abord recommencer la quête du cadeau"
  ],
  "Bet is not eligible for the Gift Race because your current bets will be decisive": [
    null,
    "Le pari n'est pas éligible à La Course aux Cadeaux car tes paris en cours seront décisifs"
  ],
  "Bet modification unavailable": [
    null,
    "Modification non disponible"
  ],
  "Bet modification unavailable with free bets": [
    null,
    "Modification non disponible sur les paris gratuits"
  ],
  "Bet pending": [
    null,
    "Pari en attente"
  ],
  "Bet refused": [
    null,
    "Pari refusé"
  ],
  "Bet stopped": [
    null,
    "Pari terminé"
  ],
  "Bet suspended": [
    null,
    "Pari suspendu"
  ],
  "Bet tax free": [
    null,
    ""
  ],
  "Bet validated": [
    null,
    "Pari validé"
  ],
  "Bet validated!": [
    null,
    "Pari validé !"
  ],
  "Bet validation in progress": [
    null,
    "Pari en cours de validation"
  ],
  "Bets on the competition": [
    null,
    "paris sur la compétition"
  ],
  "Betslip": [
    null,
    "Panier"
  ],
  "Betting with Winamax": [
    null,
    "Parier sur Winamax"
  ],
  "Biggest accumulators": [
    null,
    "Les meilleurs combos"
  ],
  "Biggest winnings": [
    null,
    "Les plus gros gains"
  ],
  "Blocks": [
    null,
    "Contres"
  ],
  "Boom %1$s internal error": [
    null,
    "Erreur interne de Boom %1$s"
  ],
  "Boom St Valentine": [
    null,
    "Boom St Valentin"
  ],
  "Borussia M'Gladbach": [
    null,
    "Borussia M'Gladbach"
  ],
  "Both teams": [
    null,
    "Les deux équipes"
  ],
  "Bracket": [
    null,
    "Tableau"
  ],
  "Bravo!": [
    null,
    "Bravo !"
  ],
  "By ticking this box, your grid will be made private.": [
    null,
    "En cochant cette case, ta grille sera privée."
  ],
  "Cancelled": [
    null,
    "Annulé"
  ],
  "Cashout": [
    null,
    "Cashout"
  ],
  "Cashout (max %1$s)": [
    null,
    "Cashout (max %1$s)"
  ],
  "Cashout validated": [
    null,
    "Cashout validé"
  ],
  "Cashout validation in progress": [
    null,
    "Cashout en cours de validation"
  ],
  "Cashout €%1$s": [
    null,
    "Cashout %1$s €"
  ],
  "Cashout: %2$s available": [
    "Cashout: %2$s available",
    "Cashout: %2$s disponible",
    "Cashout: %2$s disponibles"
  ],
  "Certain data may not be up to date.": [
    null,
    "Certaines données ne sont peut-être pas à jour."
  ],
  "Check out the public grids as well as information about the authors of these grids and find the one that suits you best.": [
    null,
    "Consulte les grilles publiques ainsi que les infos sur les auteurs de ces grilles et trouve celle qui te correspond le plus."
  ],
  "Check the full rules": [
    null,
    "Retrouve le règlement complet"
  ],
  "Choose the amount of your stake on this grid as a team.": [
    null,
    "Choisis le montant de ta mise sur cette grille en équipe."
  ],
  "Choose your format (7 or 12 matches) and validate your own grid.": [
    null,
    "Choisis ton format (7 ou 12 matchs) et valide ta propre grille."
  ],
  "Christmas is already over!": [
    null,
    "Noel, c'est déjà terminé !"
  ],
  "Claim": [
    null,
    "Récupérer"
  ],
  "Click and hold an image to save or share": [
    null,
    "Maintiens appuyé sur le visuel pour l'enregistrer ou le partager."
  ],
  "Close": [
    null,
    "Fermer"
  ],
  "Close details": [
    null,
    "Fermer le détail"
  ],
  "Combinations": [
    null,
    "Les combinaisons"
  ],
  "Combo booster": [
    null,
    "Combo booster"
  ],
  "Compact grid": [
    null,
    "Grille compacte"
  ],
  "Compact view": [
    null,
    "Vue compacte"
  ],
  "Competitions": [
    null,
    "Compétitions"
  ],
  "Complete all 3 phases of the game by placing winning bets and walk away with legendary gifts and lots of Freebets:": [
    null,
    "Franchis les 3 phases du jeu en enchaînant les paris gagnants et repars avec des cadeaux légendaires et plein de Freebets :"
  ],
  "Complete bet": [
    null,
    "Compléter mon pari"
  ],
  "Confirm": [
    null,
    "Valider"
  ],
  "Congratulations on your journey!": [
    null,
    "Félicitations pour ton parcours !"
  ],
  "Congratulations!": [
    null,
    "Félicitations !"
  ],
  "Connection error.": [
    null,
    "Une erreur de connexion réseau est survenue."
  ],
  "Contradictory selections": [
    null,
    "Sélections contradictoires"
  ],
  "Contradictory selections.": [
    null,
    "Les sélections sont contradictoires."
  ],
  "Contradictory selections. Check your betslip.": [
    null,
    "Les sélections sont contradictoires. Vérifie ton panier."
  ],
  "Copied": [
    null,
    "Copié"
  ],
  "Copy": [
    null,
    "Copier"
  ],
  "Copy the link": [
    null,
    "Copier le lien"
  ],
  "Countries": [
    null,
    "Pays"
  ],
  "Dead-Heat": [
    null,
    "Cas d'égalité"
  ],
  "Decisive": [
    null,
    "Décisif"
  ],
  "Decisive players": [
    null,
    "Joueurs décisifs"
  ],
  "Delete grid": [
    null,
    "Supprimer la grille"
  ],
  "Delete my favourites": [
    null,
    "Retirer tous mes favoris"
  ],
  "Detailed grids": [
    null,
    "Grilles détaillées"
  ],
  "Didn't understand everything on the previous screen?": [
    null,
    "Tu n'as pas tout compris à l'écran précédent ?"
  ],
  "Direct free kick": [
    null,
    "Coup franc direct"
  ],
  "Display sliders on relevant bets by default": [
    null,
    "Afficher par défaut les curseurs sur les paris concernés"
  ],
  "Do you like this application?": [
    null,
    "Tu aimes cette application ?"
  ],
  "Do you want to keep a low profile and only share your grid with your friends? Opt for the private grid.": [
    null,
    "Tu veux rester discret et partager ta grille qu'entre potes ? Opte pour la grille privée."
  ],
  "Do you wish to comment on this application?": [
    null,
    "Souhaites-tu donner ton avis et noter cette application ?"
  ],
  "Don't save bet": [
    null,
    "Ne plus enregistrer le pari"
  ],
  "Draw": [
    null,
    "Match nul"
  ],
  "Duplicate grid": [
    null,
    "Dupliquer la grille"
  ],
  "Each simple bet is placed individually": [
    null,
    "Chaque pari simple est placé individuellement"
  ],
  "Edit": [
    null,
    "Modifier"
  ],
  "Enhance": [
    null,
    "Compléter"
  ],
  "Error whilst crediting your reward": [
    null,
    "Erreur lors de la rétribution de votre récompense"
  ],
  "Error, please try again": [
    null,
    "Erreur, veuillez réessayer"
  ],
  "Event abandoned": [
    null,
    "Événement abandonné"
  ],
  "Event cancelled": [
    null,
    "Événement annulé"
  ],
  "Event ended": [
    null,
    "Evènement terminé"
  ],
  "Event postponed": [
    null,
    "Événement reporté"
  ],
  "Eventual winnings will be shared in proportion to each player's stake.": [
    null,
    "Les gains éventuels seront partagés au prorata de la mise de chaque participant."
  ],
  "Excluding extra-time and penalty shoot-out.": [
    null,
    "Hors prolongations et tirs au but éventuels."
  ],
  "Explode Cupid by winnings 5 bets": [
    null,
    "Fais exploser Cupidon en gagnant 5 paris"
  ],
  "Explode the leprechaun by winnings 5 bets": [
    null,
    "Fais exploser le leprechaun en gagnant 5 paris"
  ],
  "Explode your pumpkin by winnings 5 bets": [
    null,
    "Fais exploser ta citrouille en gagnant 5 paris"
  ],
  "Extras": [
    null,
    "Extras"
  ],
  "FC Porto": [
    null,
    "FC Porto"
  ],
  "Filter bets": [
    null,
    "Filtrer les paris"
  ],
  "Finance your entire grid or share the jackpot by playing as a team.": [
    null,
    "Finance l'intégralité de ta grille ou partage le pactole en jouant en équipe."
  ],
  "Find out how much you've pocketed as soon as the last game of your grid ends.": [
    null,
    "Découvre dès la fin du dernier match de ta grille combien tu as empoché."
  ],
  "First": [
    null,
    "Premier"
  ],
  "Flash": [
    null,
    "Flash"
  ],
  "Follow the live results and stats of your grids.": [
    null,
    "Suis en direct les résultats et rapports de tes grilles."
  ],
  "For a 24h break hold the button pressed for 3 seconds.": [
    null,
    "For a 24h break hold the button pressed for 3 seconds."
  ],
  "Format change": [
    null,
    "Changement de format"
  ],
  "Frame %1$s": [
    null,
    "Manche %1$s"
  ],
  "Freebet Wager": [
    null,
    "Mise Freebets"
  ],
  "Freebet win for the complete colour collection: Reference bet x %1$s": [
    null,
    "Gain Freebets si groupe de couleur complet : Mise de référence x %1$s"
  ],
  "Freebet winnings if you win this level: Reference bet x %1$s": [
    null,
    "Gain Freebets si tu gagnes ce niveau : mise de référence x %1$s"
  ],
  "Freebets Wager": [
    null,
    "Mise Freebets"
  ],
  "Game objective": [
    null,
    "But du jeu"
  ],
  "Gather properties, complete colour collections and win lots of Freebets!": [
    null,
    "Remportez les propriétés, complétez les groupes de couleur et gagnez un max de Freebets !"
  ],
  "General problem": [
    null,
    "Problème général"
  ],
  "Get started": [
    null,
    "Commencer"
  ],
  "Gift Race internal error": [
    null,
    "Erreur interne de La Course aux Cadeaux"
  ],
  "Goalscorer Duo": [
    null,
    "Duo Buteurs"
  ],
  "Goalscorer Guarantee": [
    null,
    "Garantie Buteur"
  ],
  "Goalscorer Trio": [
    null,
    "Trio Buteurs"
  ],
  "Goalscorer in a period": [
    null,
    "Buteurs lors d'un tiers-temps"
  ],
  "Goalscorers in a 10 min period": [
    null,
    "Buteurs lors d'une période de 10 min"
  ],
  "Goalscorers in a 15 min period": [
    null,
    "Buteurs lors d'une période de 15 min"
  ],
  "Graphics preferences": [
    null,
    "Préférences graphiques"
  ],
  "Grid": [
    null,
    "Grille"
  ],
  "Grid %1$s winnings": [
    null,
    "Gains grille %1$s"
  ],
  "Grid price": [
    null,
    "Prix de la grille"
  ],
  "Grid result": [
    null,
    "Résultats de la grille"
  ],
  "Grids": [
    null,
    "Grilles"
  ],
  "Grids Home": [
    null,
    "Home"
  ],
  "Guarantee:": [
    null,
    "Montant garanti :"
  ],
  "Half time - Multiple goalscorers": [
    null,
    "Mi-temps - Buteurs multiples"
  ],
  "Half-time goalscorers": [
    null,
    "Buteurs lors d'une mi-temps"
  ],
  "Halloween": [
    null,
    "Halloween"
  ],
  "Header": [
    null,
    "Tête"
  ],
  "Hidden": [
    null,
    "Masqués"
  ],
  "Hide bet": [
    null,
    "Masquer le pari"
  ],
  "Highest MyMatch odds": [
    null,
    "Les plus grosses cotes MyMatch"
  ],
  "Highest odds": [
    null,
    "Les plus grosses cotes"
  ],
  "Home": [
    null,
    "Home"
  ],
  "If you lose a bet, you start the phase from 0.": [
    null,
    "Si tu perds un pari, tu repars de 0 sur la phase."
  ],
  "Important account information": [
    null,
    "Informations relatives à votre compte"
  ],
  "In Play": [
    null,
    "Live"
  ],
  "In progress": [
    null,
    "En cours"
  ],
  "Incorrect PIN": [
    null,
    "Code pin incorrect."
  ],
  "Incorrect amount": [
    null,
    "La mise est incorrecte"
  ],
  "Incorrect email, password or date of birth": [
    null,
    "Mauvais email/mot de passe/date de naissance"
  ],
  "Individual grid": [
    null,
    "Grille perso"
  ],
  "Inter Milan": [
    null,
    "Inter Milan"
  ],
  "Internal error": [
    null,
    "Erreur interne"
  ],
  "It's not the grids that matter, it's what you do with them!": [
    null,
    "L'important ce ne sont pas les grilles, c'est ce que tu en fais !"
  ],
  "It's simple! Select a result of your choice (team 1 or team 2 or draw) for each match.": [
    null,
    "C'est très simple ! Pour chaque match, sélectionne le résultat de ton choix (équipe 1 ou équipe 2 ou match nul)."
  ],
  "Koh-Lanta": [
    null,
    "Koh-Lanta"
  ],
  "Lacking inspiration? You can also take part in a public grid.": [
    null,
    "En manque d'inspiration ? Tu peux aussi participer à une grille publique."
  ],
  "Last": [
    null,
    "Dernier"
  ],
  "Later": [
    null,
    "Plus tard"
  ],
  "Least expensive": [
    null,
    "Les moins chères"
  ],
  "Less selections": [
    null,
    "Moins de sélections"
  ],
  "Level %1$s": [
    null,
    "Niveau %1$s"
  ],
  "Line %1$s": [
    null,
    "Ligne %1$s"
  ],
  "Link copied!": [
    null,
    "Lien copié !"
  ],
  "Live": [
    null,
    "Live"
  ],
  "Liverpool": [
    null,
    "Liverpool"
  ],
  "Loading": [
    null,
    "Chargement"
  ],
  "Loading in progress": [
    null,
    "Chargement en cours"
  ],
  "Log in": [
    null,
    "Se connecter"
  ],
  "Log in to %1$s": [
    null,
    "Je me connecte sur %1$s"
  ],
  "Lost": [
    null,
    "Perdu"
  ],
  "Maintenance in progress": [
    null,
    "Maintenance en cours"
  ],
  "Maintenance in progress.": [
    null,
    "Maintenance en cours."
  ],
  "Manchester City": [
    null,
    "Manchester City"
  ],
  "Manchester United": [
    null,
    "Manchester United"
  ],
  "Map %1$s": [
    null,
    "Map %1$s"
  ],
  "Marseille": [
    null,
    "Marseille"
  ],
  "Match": [
    null,
    "Match"
  ],
  "Match details": [
    null,
    "Détails des matchs"
  ],
  "Match details and odds": [
    null,
    "Infos et cotes du match"
  ],
  "Match ended": [
    null,
    "Match terminé"
  ],
  "Match odds": [
    null,
    "Les cotes du match"
  ],
  "Match result odds": [
    null,
    "Cotes du résultat du match"
  ],
  "Match unavailable": [
    null,
    "Match indisponible"
  ],
  "Matches": [
    null,
    "Matchs"
  ],
  "Maximum selections reached": [
    null,
    "Nombre maximum de sélections atteint"
  ],
  "Min. odds": [
    null,
    "Cote mini"
  ],
  "Min. odds:": [
    null,
    "Cote mini :"
  ],
  "Min. wager:": [
    null,
    "Mise mini :"
  ],
  "Minimum odds to win this card: %1$s": [
    null,
    "Cote minimum pour gagner cette carte : %1$s"
  ],
  "Minimum odds to win this level: %1$s": [
    null,
    "Cote minimum pour gagner ce niveau : %1$s"
  ],
  "Monopoly internal error": [
    null,
    "Erreur interne du Monopoly"
  ],
  "More selections": [
    null,
    "Plus de sélections"
  ],
  "Most advanced": [
    null,
    "Les plus avancées"
  ],
  "Most expensive": [
    null,
    "Les plus chères"
  ],
  "Most popular": [
    null,
    "Les plus populaires"
  ],
  "Most recent": [
    null,
    "Les plus récentes"
  ],
  "Multiples:": [
    null,
    "Combinaisons :"
  ],
  "Multiscorers": [
    null,
    "Buteurs multiples"
  ],
  "My bets": [
    null,
    "Mes paris"
  ],
  "My collection": [
    null,
    "Ma collection"
  ],
  "My favourites": [
    null,
    "Mes Favoris"
  ],
  "My grids": [
    null,
    "Mes grilles"
  ],
  "My wager": [
    null,
    "Ma mise"
  ],
  "My winnings": [
    null,
    "Mes gains"
  ],
  "MyMatch currently unavailable": [
    null,
    "MyMatch actuellement indisponible."
  ],
  "MyMatch mode": [
    null,
    "Mode MyMatch"
  ],
  "MyMatch unavailable": [
    null,
    "MyMatch indisponible"
  ],
  "News": [
    null,
    "News"
  ],
  "Next": [
    null,
    "Suivant"
  ],
  "Next grid": [
    null,
    "Prochaine grille"
  ],
  "Next grids": [
    null,
    "Prochaines grilles"
  ],
  "No": [
    null,
    "Non"
  ],
  "No bets": [
    null,
    "Aucun pari"
  ],
  "No grid": [
    null,
    "Aucune grille"
  ],
  "No grid played": [
    null,
    "Aucune grille"
  ],
  "No grids": [
    null,
    "Aucune grille"
  ],
  "No grids cancelled": [
    null,
    "Aucune grille annulée"
  ],
  "No grids lost": [
    null,
    "Aucune grille perdue"
  ],
  "No grids running": [
    null,
    "Aucune grille en cours"
  ],
  "No grids won": [
    null,
    "Aucune grille gagnée"
  ],
  "No public grids": [
    null,
    "Aucune grille publique"
  ],
  "No rank 1 winners": [
    null,
    "Aucun gagnant rang 1"
  ],
  "No results": [
    null,
    "Pas de résultat"
  ],
  "No team": [
    null,
    "Aucune équipe"
  ],
  "Non-top 10 competitor": [
    null,
    "Concurrent hors top 10"
  ],
  "Non-top 30 competitor": [
    null,
    "Concurrent hors top 30"
  ],
  "Not enough combinations": [
    null,
    "Trop peu de combinaison"
  ],
  "Notifications": [
    null,
    "Notifications"
  ],
  "Number": [
    null,
    "Nombre"
  ],
  "Number of bets": [
    null,
    "Nombre de paris "
  ],
  "Number of goals from the player": [
    null,
    "Nombre de buts du joueur"
  ],
  "Odds": [
    null,
    "Cote"
  ],
  "Odds equal or inferior to 1": [
    null,
    "Cote inférieure ou égale à 1,00"
  ],
  "Odds:": [
    null,
    "Cote :"
  ],
  "Official lineups": [
    null,
    "Compositions officielles"
  ],
  "Official starting lineups": [
    null,
    "5 majeurs officiels"
  ],
  "Ok": [
    null,
    "Ok"
  ],
  "Olympiakos": [
    null,
    "Olympiakos"
  ],
  "One or multiple selections are unavailable": [
    null,
    "Une ou plusieurs sélections sont indisponibles"
  ],
  "Ongoing": [
    null,
    "En cours"
  ],
  "Oops,": [
    null,
    "Oups,"
  ],
  "Open the App Store": [
    null,
    "Ouvrir l’App Store"
  ],
  "PRA": [
    null,
    "PRP"
  ],
  "Paris SG": [
    null,
    "Paris SG"
  ],
  "Penalty": [
    null,
    "Penalty"
  ],
  "Penalty try": [
    null,
    "Essai de pénalité"
  ],
  "Pending %1$s bets": [
    null,
    "Pari %1$s en attente"
  ],
  "Pending bet refused": [
    null,
    "Pari en attente refusé"
  ],
  "Pending bet validated": [
    null,
    "Pari en attente validé"
  ],
  "Permanent and past promotions": [
    null,
    "Offres permanentes et passées"
  ],
  "Phase 1: Pegasus Shoes": [
    null,
    "Phase 1 : les crampons de Pégase"
  ],
  "Phase 2: The remote control ball": [
    null,
    "Phase 2 : le ballon télécommandé"
  ],
  "Phase 3: The Chameleon Jersey": [
    null,
    "Phase 3 : le maillot caméléon"
  ],
  "Place a series of winning bets to score %1$s points.": [
    null,
    "Enchaîne les paris gagnants afin de marquer %1$s points."
  ],
  "Play the game to try and win a ton of Freebets!": [
    null,
    "Participe au jeu pour tenter\nde gagner un max de Freebets !"
  ],
  "Player": [
    null,
    "Joueur"
  ],
  "Player vs. player": [
    null,
    "Joueur contre joueur"
  ],
  "Player vs. team": [
    null,
    "Joueur contre équipe"
  ],
  "Please enter a valid amount.": [
    null,
    "Indique un montant valide."
  ],
  "Please enter your date of birth": [
    null,
    "La date de naissance est obligatoire"
  ],
  "Points": [
    null,
    "Points"
  ],
  "Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.": [
    null,
    "Barème des points : 100 x produit(cotes gagnantes). Ainsi, si tes 3 premiers paris sont gagnants, tu remportes 100 x cote1 x cote2 x cote3 points."
  ],
  "Points+assists": [
    null,
    "Points+passes"
  ],
  "Points+rebounds": [
    null,
    "Points+rebonds"
  ],
  "Poker": [
    null,
    "Poker"
  ],
  "Potential winnings": [
    null,
    "Gains potentiels "
  ],
  "Previous": [
    null,
    "Précédent"
  ],
  "Prize distribution per player": [
    null,
    "Répartition par joueur"
  ],
  "Prizepool": [
    null,
    "Dotation"
  ],
  "Probable starting lineups": [
    null,
    "5 majeurs probables"
  ],
  "Prohibited": [
    null,
    "Interdit"
  ],
  "Prohibited (no-stakes game)": [
    null,
    "Interdit (match sans enjeux)"
  ],
  "Projected lineups": [
    null,
    "Compositions probables"
  ],
  "Provisional grid result": [
    null,
    "Résultat provisoire"
  ],
  "Provisional prize distribution": [
    null,
    "Répartition provisoire"
  ],
  "Public grid": [
    null,
    "Grille publique"
  ],
  "Public grids": [
    null,
    "Grilles publiques"
  ],
  "Real Madrid": [
    null,
    "Real Madrid"
  ],
  "Rebounds": [
    null,
    "Rebonds"
  ],
  "Ref:": [
    null,
    "Réf :"
  ],
  "Reference": [
    null,
    "Référence"
  ],
  "Reference bet: the smallest bet of the levels you have won (max %1$s)": [
    null,
    "Mise de référence : la plus petite mise des niveaux gagnés (max %1$s)"
  ],
  "Refuse": [
    null,
    "Refuser"
  ],
  "Refused": [
    null,
    "Refusé"
  ],
  "Repeat this bet": [
    null,
    "Reprendre ce pari"
  ],
  "Reset": [
    null,
    "Réinitialiser"
  ],
  "Reset the grid": [
    null,
    "Réinitialiser la grille"
  ],
  "Result": [
    null,
    "Résultat"
  ],
  "Retired or defaulted": [
    null,
    "Abandon ou disqualification"
  ],
  "Reviews": [
    null,
    "Rapports"
  ],
  "Right-click an image to copy it or to save it on your device": [
    null,
    "Faites un clic droit sur l'image pour la copier ou l'enregistrer sur votre appareil."
  ],
  "Rules": [
    null,
    "Règlement"
  ],
  "Running": [
    null,
    "En cours"
  ],
  "Save bet": [
    null,
    "Enregistrer le pari"
  ],
  "Save my selection": [
    "Save my selections",
    "Conserver ma sélection",
    "Conserver mes sélections"
  ],
  "Saved": [
    null,
    "Enregistrés"
  ],
  "Scan a bonus code": [
    null,
    "Scanner un code bonus"
  ],
  "Scorer": [
    null,
    "Buteur"
  ],
  "Scorer type": [
    null,
    "Type de but du joueur"
  ],
  "Scorers": [
    null,
    "Buteurs"
  ],
  "Search": [
    null,
    "Rechercher"
  ],
  "See all": [
    null,
    "Tout voir"
  ],
  "See all odds": [
    null,
    "voir toutes les cotes"
  ],
  "See details": [
    null,
    "Détails"
  ],
  "See more selections": [
    null,
    "Voir plus de sélections"
  ],
  "See top matches": [
    null,
    "Voir les top matchs"
  ],
  "Select": [
    null,
    "Sélectionner"
  ],
  "Service unavailable": [
    null,
    "Le service est indisponible"
  ],
  "Settings": [
    null,
    "Paramètres"
  ],
  "Shaktar Donetsk": [
    null,
    "Shaktar Donetsk"
  ],
  "Share bet to a friend's basket": [
    null,
    "Partager le pari vers le panier d'un pote"
  ],
  "Share image": [
    null,
    "Partager l'image"
  ],
  "Share my bet": [
    null,
    "Je partage mon pari"
  ],
  "Share options": [
    null,
    "Options de partage"
  ],
  "Shop": [
    null,
    "Boutique"
  ],
  "Show animation when adding a selection to betslip": [
    null,
    "Afficher une animation lors d'un ajout de sélection au panier"
  ],
  "Show bet": [
    null,
    "Ne plus masquer le pari"
  ],
  "Show username": [
    null,
    "Afficher le pseudo"
  ],
  "Show wager and winnings": [
    null,
    "Afficher la mise et les gains"
  ],
  "Sign-in": [
    null,
    "Se connecter"
  ],
  "Sign-in and place bet": [
    null,
    "Se connecter et parier"
  ],
  "Sign-up": [
    null,
    "S'inscrire"
  ],
  "Simple touchdown scorer": [
    null,
    "Marqueur"
  ],
  "Single": [
    null,
    "Simple"
  ],
  "Skip all": [
    null,
    "Tout passer"
  ],
  "Sports": [
    null,
    "Sports"
  ],
  "Sports bets": [
    null,
    "Paris sportifs"
  ],
  "St Patrick": [
    null,
    "St Patrick"
  ],
  "St Valentine": [
    null,
    "St Valentin"
  ],
  "Start": [
    null,
    "Commencer"
  ],
  "Start again": [
    null,
    "Recommencer"
  ],
  "Starter": [
    null,
    "Titulaire"
  ],
  "Starters": [
    null,
    "Titulaires"
  ],
  "Starting 5 Guarantee": [
    null,
    "Garantie 5 Majeur"
  ],
  "Stats": [
    null,
    "Stats"
  ],
  "Steals": [
    null,
    "Interceptions"
  ],
  "Steals+blocks": [
    null,
    "Interceptions+contres"
  ],
  "Substitutes": [
    null,
    "Remplaçants"
  ],
  "System": [
    null,
    "Système"
  ],
  "System %1$s": [
    null,
    "Système %1$s"
  ],
  "System %1$s/%2$s": [
    null,
    "Système %1$s/%2$s"
  ],
  "System bet": [
    null,
    "Pari système"
  ],
  "System grid": [
    null,
    "Grille système"
  ],
  "System grid price": [
    null,
    "Prix de la grille système"
  ],
  "Take part": [
    null,
    "Participer"
  ],
  "Team 1": [
    null,
    "Équipe n°1"
  ],
  "Team 2": [
    null,
    "Équipe n°2"
  ],
  "Team grid": [
    null,
    "Grille en équipe"
  ],
  "Terms and Conditions and Privacy Policy": [
    null,
    "Conditions Générales d'Utilisation et Politique de confidentialité"
  ],
  "The Gift Race": [
    null,
    "La Course aux Cadeaux"
  ],
  "The Pegasus shoes to fly over your next match": [
    null,
    "Les crampons de Pégase pour survoler ton prochain match"
  ],
  "The bet is not eligible for Boom %1$s because Freebets are not taken into account": [
    null,
    "Le pari n'est pas éligible à Boom %1$s car les Freebets ne sont pas pris en compte"
  ],
  "The bet is not eligible for Monopoly because Freebets are not taken into account": [
    null,
    "Le pari n’est pas éligible à Monopoly car les mises en Freebets ne sont pas prises en compte"
  ],
  "The chameleon jersey to change teams in a flash": [
    null,
    "Le maillot caméléon pour changer d'équipe en un éclair"
  ],
  "The classic accumulator wins if the %1$s are correct": [
    null,
    "Le combiné classique, gagnant si les %1$s sont corrects"
  ],
  "The date of birth entered does not match the date registered on your account": [
    null,
    "La date de naissance saisie ne correspond pas à celle du compte."
  ],
  "The date of birth you have entered is invalid": [
    null,
    "La date de naissance saisie n'est pas valable."
  ],
  "The game is over": [
    null,
    "Le jeu est terminé"
  ],
  "The game will end in under 24 hours": [
    null,
    "Le jeu se termine dans moins de 24h"
  ],
  "The maximum stake for this bet has already been reached, or the stake is lower than the minimum of €0.10": [
    null,
    "La mise maximale pour ce pari est déjà atteinte ou est inférieure à la mise minimale 0,10 €"
  ],
  "The maximum wager is %1$s": [
    null,
    "La mise maximale pour ce pari est de %1$s"
  ],
  "The minimum odds are %1$s": [
    null,
    "La cote minimale est de %1$s"
  ],
  "The minimum wager is %1$s": [
    null,
    "La mise minimale est de %1$s"
  ],
  "The odds have changed": [
    null,
    "La cote a changé"
  ],
  "The prize for this collection has already been claimed": [
    null,
    "La récompense associée à cette collection a déjà été récupérée"
  ],
  "The remote-controlled ball with its unpredictable trajectories": [
    null,
    "Le ballon télécommandé et ses trajectoires imprévisibles"
  ],
  "The service is currently unavailable. We will restore this as soon as possible. We apologise for any inconveniences caused by this.": [
    null,
    "Le service est momentanément indisponible. Il sera rétabli dans les meilleurs délais. Merci de nous excuser pour la gêne occasionnée."
  ],
  "The system grid is an expert mode. It allows you to create complex grids with some basic matches.": [
    null,
    "Le mode grille système est un mode expert. Il te permet de réaliser des grilles complexes avec certains matchs en base."
  ],
  "The video could not be loaded as it is an unsupported video format or due to a server issue.": [
    null,
    "La vidéo n'a pas pu être chargée en raison d'un format non pris en charge ou d'une erreur serveur."
  ],
  "This QR code is not a Winamax bonus code": [
    null,
    "Ce code QR n'est pas un code bonus Winamax"
  ],
  "This broadcast is not available in your country of residence.": [
    null,
    "La diffusion de cette vidéo n'est pas autorisée dans votre pays."
  ],
  "This code is not a Winamax bonus code or has already been credited": [
    null,
    "Ce code n'est pas un code bonus Winamax ou a déjà été crédité"
  ],
  "This event is no longer available": [
    null,
    "L'évènement n'est plus disponible"
  ],
  "This free bet cannot be used": [
    null,
    "Impossible d'utiliser ce pari gratuit"
  ],
  "This match is already included in the betslip you wish to enhance.": [
    null,
    "Ce match est déjà présent dans le pari que tu souhaites compléter."
  ],
  "This promotion has ended": [
    null,
    "Cette opération est maintenant terminée"
  ],
  "This promotion will end in under 24 hours": [
    null,
    "Cette opération va se terminer dans moins de 24h"
  ],
  "This version of the software is not supported": [
    null,
    "Version de l’application non supportée"
  ],
  "This video could not be loaded as it has unsupported functionalities.": [
    null,
    "La vidéo n'a pas pu être chargée en raison de fonctionnalités non prises en charge."
  ],
  "Three-pointers": [
    null,
    "Paniers 3 points"
  ],
  "Tick the boxes in your grid.": [
    null,
    "Coche les cases de ta grille."
  ],
  "To be won": [
    null,
    "À gagner"
  ],
  "Tomorrow": [
    null,
    "Demain"
  ],
  "Too many attempts.": [
    null,
    "Trop de tentatives infructueuses."
  ],
  "Too many bankers": [
    null,
    "Trop de bases sélectionnées"
  ],
  "Too many bets selected": [
    null,
    "Trop de paris sélectionnés"
  ],
  "Too many selections": [
    null,
    "Trop de sélections"
  ],
  "Top competitions": [
    null,
    "Top compétitions"
  ],
  "Total": [
    null,
    "Total"
  ],
  "Total away": [
    null,
    "Total extérieur"
  ],
  "Total home": [
    null,
    "Total domicile"
  ],
  "Total odds": [
    null,
    "Cote totale"
  ],
  "Total wager": [
    null,
    "Mise totale "
  ],
  "Total winnings": [
    null,
    "Total des gains "
  ],
  "Touchdowns scorers": [
    null,
    "Marqueurs de touchdowns"
  ],
  "Try again": [
    null,
    "Réessayer"
  ],
  "Try scorer Duo": [
    null,
    "Duo marqueurs d'essai"
  ],
  "Try scorer Trio": [
    null,
    "Trio marqueurs d'essai"
  ],
  "Try scorers": [
    null,
    "Marqueurs d'essais"
  ],
  "Try:": [
    null,
    "Essayer :"
  ],
  "Turnovers": [
    null,
    "Ballons perdus"
  ],
  "Type of goal scored by a team": [
    null,
    "Type de but d'une équipe"
  ],
  "Unable to calculate odds": [
    null,
    "Impossible de calculer la cote"
  ],
  "Upcoming matches": [
    null,
    "Matchs à venir (calendrier)"
  ],
  "Update": [
    null,
    "Mettre à jour"
  ],
  "Use Freebets": [
    null,
    "Parier en Freebets"
  ],
  "Use a bonus": [
    null,
    "Utiliser un bonus"
  ],
  "Video unavailable": [
    null,
    "Vidéo indisponible."
  ],
  "View my bet": [
    null,
    "Voir mon pari"
  ],
  "View the most wagered bets in the last %1$s mins": [
    null,
    "Découvre les paris les plus misés depuis %1$s min"
  ],
  "View the most wagered bets in the last hour": [
    null,
    "Découvre les paris les plus misés depuis une heure"
  ],
  "Wager": [
    null,
    "Mise "
  ],
  "Wager:": [
    null,
    "Mise :"
  ],
  "Walkover": [
    null,
    ""
  ],
  "Want another accumulator? Switch to MyMatch!": [
    null,
    "Tu veux une autre combinaison? Bascule en mode MyMatch !"
  ],
  "Want another multi-chance accumulator? Switch to MyMatch!": [
    null,
    "Tu veux une autre combinaison multichance ? Bascule en mode MyMatch !"
  ],
  "Want to check out all the promotions Winamax has to offer?": [
    null,
    "Envie de découvrir l'ensemble des offres sur Winamax ?"
  ],
  "Warning:": [
    null,
    "Attention :"
  ],
  "We were unable to generate your final image": [
    null,
    "Nous n'avons pas pu générer ton image finale."
  ],
  "We'll explain everything step by step!": [
    null,
    "On t'explique tout pas à pas !"
  ],
  "Welcome to the grid tutorial": [
    null,
    "Bienvenue dans le tuto des grilles"
  ],
  "Win a ton of Freebets along the way!": [
    null,
    "Gagne un max de Freebets en chemin !"
  ],
  "Win all previous levels in order to unlock this level": [
    null,
    "Gagne les niveaux précédents afin de débloquer ce niveau"
  ],
  "Win up to": [
    null,
    "Remporte jusqu'à"
  ],
  "Win up to %1$s times your reference bet in Freebets!": [
    null,
    "Gagne jusqu'à %1$s fois ta mise de référence en Freebets !"
  ],
  "WinaTV channel": [
    null,
    "WinaTV - La chaine"
  ],
  "Winamax QR code": [
    null,
    "Code QR Winamax"
  ],
  "Winamax grid": [
    null,
    "Grille Winamax"
  ],
  "Winning is everything": [
    null,
    "Le plus important, c’est de gagner"
  ],
  "Winnings": [
    null,
    "Gains"
  ],
  "Winnings %1$s": [
    null,
    "Gains %1$s"
  ],
  "Winnings inferior or equal to the wager": [
    null,
    "Gain inférieur ou égal à la mise"
  ],
  "Won": [
    null,
    "Gagné"
  ],
  "Xmas": [
    null,
    "Noël"
  ],
  "Yes": [
    null,
    "Oui"
  ],
  "You aborted the media playback.": [
    null,
    "Tu as interrompu la lecture de la vidéo."
  ],
  "You are currently excluded from Monopoly due to your game limits": [
    null,
    "Vous êtes actuellement exclu à Monopoly dans vos limites de jeu"
  ],
  "You are currently excluded from betting promotions in your %1$s": [
    null,
    "Vous êtes actuellement exclus des offres de paris sportifs dans vos %1$s."
  ],
  "You are currently excluded from the Gift Race due to your game limits": [
    null,
    "Vous êtes actuellement exclu de La Course aux Cadeaux dans vos limites de jeu"
  ],
  "You are currently ineligible for Boom %1$s": [
    null,
    "Vous n'êtes actuellement pas éligible à Boom %1$s"
  ],
  "You are currently ineligible for Monopoly": [
    null,
    "Vous n'êtes actuellement pas éligible à Monopoly"
  ],
  "You are currently ineligible for the Gift Race": [
    null,
    "Vous n'êtes actuellement pas éligible à La Course aux Cadeaux"
  ],
  "You are currently not eligible to betting promotions": [
    null,
    "Vous n'êtes actuellement pas éligible aux offres de paris sportifs."
  ],
  "You are not authorized to connect from this country.": [
    null,
    "Vous n'êtes pas autorisé à vous connecter depuis ce pays."
  ],
  "You can also make doubles or triples to increase your chances of winning": [
    null,
    "Tu peux également faire des doubles ou des triples pour augmenter tes chances de gagner"
  ],
  "You can also select doubles and triples to have a better chance of winning.": [
    null,
    "Tu peux cocher des doubles et des triples pour augmenter tes chances de gagner."
  ],
  "You can do so right here! :index_vers_le_bas:": [
    null,
    "C'est juste ici !"
  ],
  "You can select doubles and triples to increase your chances of winning.": [
    null,
    "Tu peux cocher des doubles et des triples pour augmenter tes chances de gagner."
  ],
  "You cannot bet on this grid anymore": [
    null,
    "Il n'est plus possible de parier sur cette grille."
  ],
  "You cannot combine multiple bets on the same match": [
    null,
    "Tu ne peux pas combiner plusieurs paris sur le même match"
  ],
  "You cannot combine these bets": [
    null,
    "Tu ne peux pas combiner ces paris"
  ],
  "You have already placed the same bet recently": [
    null,
    "Tu as déjà placé le même pari récemment"
  ],
  "You have already received your reward": [
    null,
    "Tu as déjà reçu ta récompense"
  ],
  "You have been active for %1$s minutes now.": [
    null,
    "Vous êtes actif depuis %1$s minutes maintenant."
  ],
  "You have exceeded the maximum stake for this bet": [
    null,
    "La mise maximale pour ce pari est dépassée"
  ],
  "You have made a request to change your password. Please check your emails.": [
    null,
    "Vous avez fait une demande de changement de mot de passe. Vérifiez vos emails."
  ],
  "You have no favourites": [
    null,
    "Tu n'as aucun favori"
  ],
  "You have no funds in your account.": [
    null,
    "Tu n'as pas d'argent sur ton compte."
  ],
  "You lose": [
    null,
    "Perdu"
  ],
  "You may not receive a booster on this bet": [
    null,
    "Tu ne peux pas profiter du booster sur ce pari"
  ],
  "You must be logged": [
    null,
    "Vous devez être connecté"
  ],
  "You must be logged in to see this page": [
    null,
    "Vous devez vous connecter pour afficher cette page"
  ],
  "You must be logged in to validate your bets": [
    null,
    "Vous devez être connecté\npour valider vos paris"
  ],
  "You must be logged in to validate your grid.": [
    null,
    "Vous devez être connecter pour valider votre grille."
  ],
  "You must be of majority age to play": [
    null,
    "Vous devez être majeur pour pouvoir vous connecter."
  ],
  "You must have a minimum of €1 on your account, or you must have placed a bet on this match.": [
    null,
    "Tu dois avoir au minimum 1€ sur ton compte, ou avoir parié sur ce match."
  ],
  "You must log in to %1$s in order to access your account.": [
    null,
    "Vous devez vous connecter sur %1$s pour accéder à votre compte."
  ],
  "You must select doubles or triples to make a team grid.": [
    null,
    "Tu dois cocher des doubles ou des triples pour faire une grille en équipe."
  ],
  "You must tick at least one box per line.": [
    null,
    "Tu dois cocher au moins une case par ligne."
  ],
  "You must wager your deposit in order to withdraw it": [
    null,
    "Le dépôt doit être joué pour être retirable"
  ],
  "You only have %1$s": [
    null,
    "Tu ne disposes que de %1$s"
  ],
  "You only have %1$s in Freebets available": [
    null,
    "Tu ne disposes que de %1$s en Freebets"
  ],
  "You will earn between %1$s and %2$s times your reference bet in Freebets.": [
    null,
    "Tu gagneras ainsi entre %1$s fois et %2$s fois ta mise de référence en Freebets."
  ],
  "You will exceed your daily limit. The maximum wager is %1$s": [
    null,
    "Tu dépasserais ton modérateur quotidien. La mise maximale est de %1$s"
  ],
  "You will exceed your monthly limit. The maximum wager is %1$s": [
    null,
    "Tu dépasserais ton modérateur mensuel. La mise maximale est de %1$s"
  ],
  "You will exceed your weekly limit. The maximum wager is %1$s": [
    null,
    "Tu dépasserais ton modérateur hebdomadaire. La mise maximale est de %1$s"
  ],
  "You win": [
    null,
    "Gagnée"
  ],
  "You win Freebets": [
    null,
    "Tu gagnes en Freebets"
  ],
  "You won Freebets": [
    null,
    "Tu remportes des Freebets"
  ],
  "You've already won everything!": [
    null,
    "Tu as déjà tout gagné !"
  ],
  "Your %1$s bet could not be cashed out": [
    null,
    "Le pari %1$s n'a pas pu être racheté"
  ],
  "Your %1$s bet has been validated": [
    null,
    "Ta mise de %1$s a été validée"
  ],
  "Your %1$s bet was cashed out for %2$s": [
    null,
    "Le pari %1$s a été racheté pour un montant de %2$s"
  ],
  "Your account is frozen.": [
    null,
    "Votre compte est verrouillé."
  ],
  "Your account is locked": [
    null,
    "Votre compte est bloqué"
  ],
  "Your account is not authorized for use in this region": [
    null,
    "Votre compte n'est pas autorisé à se connecter sur cette plateforme."
  ],
  "Your app is out of date, please update to the latest version": [
    null,
    "La version de ton application est obsolète, merci de la mettre à jour."
  ],
  "Your betslip is empty!": [
    null,
    "Ton panier est vide !"
  ],
  "Your bonus code has been accepted": [
    null,
    "Votre code bonus a bien été pris en compte"
  ],
  "Your email address has not been verified. Please check your emails.": [
    null,
    "Votre compte n'est pas activé. Vérifiez vos emails."
  ],
  "Your grid has %1$s double": [
    "Your grid has %1$s doubles",
    "Ta grille comporte %1$s double",
    "Ta grille comporte %1$s doubles"
  ],
  "Your grid has been validated.": [
    null,
    "Ta grille est validée."
  ],
  "Your grid will only be validated once it has been entirely financed.": [
    null,
    "Ta grille ne sera définitivement validée qu'une fois financée dans son intégralité."
  ],
  "Your mission is simple:": [
    null,
    "Ta mission est simple :"
  ],
  "Your participation in the game has already been validated": [
    null,
    "Ta participation au jeu a déjà été validée"
  ],
  "Your turn to play!": [
    null,
    "À toi de jouer !"
  ],
  "Your winnings of %1$s will be credited to you as soon as all bets are settled.": [
    null,
    ""
  ],
  "abandoned": [
    null,
    "abondon"
  ],
  "already received": [
    null,
    "déjà acquis"
  ],
  "and %1$s triple": [
    "and %1$s triples",
    "et %1$s triple",
    "et %1$s triples"
  ],
  "break": [
    null,
    "en pause"
  ],
  "collected": [
    null,
    "collectés"
  ],
  "delayed": [
    null,
    "retardé"
  ],
  "events in progress": [
    null,
    "évènements en cours"
  ],
  "extra innings": [
    null,
    "manche supplémentaire"
  ],
  "extra-time": [
    null,
    "prolongations"
  ],
  "extra-time - 1st half": [
    null,
    "prolongations - 1re mi-temps"
  ],
  "extra-time - 2nd half": [
    null,
    "prolongations - 2de mi-temps"
  ],
  "extra-time finished": [
    null,
    "fin des prolongations"
  ],
  "extra-time half-time": [
    null,
    "mi-temps des prolongations"
  ],
  "extra-time will begin": [
    null,
    "les prolongation vont débuter"
  ],
  "free": [
    null,
    "offerts"
  ],
  "gaming limits": [
    null,
    "limites de jeu"
  ],
  "golden set": [
    null,
    "set en or"
  ],
  "grid %1$s n°%2$s": [
    null,
    "Grille %1$s n°%2$s"
  ],
  "grids": [
    null,
    "Grilles"
  ],
  "guaranteed": [
    null,
    "garantis"
  ],
  "half-time": [
    null,
    "mi-temps"
  ],
  "handicap format": [
    null,
    "format handicap"
  ],
  "how it works": [
    null,
    "Comment ça marche"
  ],
  "in progress": [
    null,
    "en cours"
  ],
  "including %1$s:": [
    null,
    "dont %1$s:"
  ],
  "including rank 1 deferral:": [
    null,
    "dont report rang 1 :"
  ],
  "match abandoned": [
    null,
    "match abandonné"
  ],
  "match delayed": [
    null,
    "match retardé"
  ],
  "match finished": [
    null,
    "fin du match"
  ],
  "match in progress": [
    null,
    "match en cours"
  ],
  "match interrupted": [
    null,
    "match interrompu"
  ],
  "match interuppted": [
    null,
    "match interrompu"
  ],
  "match postponed": [
    null,
    "match reporté"
  ],
  "match started": [
    null,
    "match en cours"
  ],
  "missions:AlreadyOpted": [
    null,
    "Participation enregistrée"
  ],
  "missions:Log in": [
    null,
    "Je me connecte"
  ],
  "missions:Opt in": [
    null,
    "Je participe"
  ],
  "most popular": [
    null,
    "les plus joués"
  ],
  "no events": [
    null,
    "aucun évènement"
  ],
  "n°": [
    null,
    "n°"
  ],
  "of the base": [
    "of %1$s bases",
    "de la base",
    "des %1$s bases"
  ],
  "ok": [
    null,
    "ok"
  ],
  "or": [
    null,
    "ou"
  ],
  "overtime": [
    null,
    "prolongation"
  ],
  "overtime finished": [
    null,
    "prolongation terminée"
  ],
  "overtime will begin": [
    null,
    "les prolongations vont débuter"
  ],
  "own goal": [
    null,
    "CSC"
  ],
  "pause": [
    null,
    "en pause"
  ],
  "penalty": [
    null,
    "penalty"
  ],
  "penalty shoot-out": [
    null,
    "tirs au but"
  ],
  "retired": [
    null,
    "forfait"
  ],
  "selection": [
    "selections",
    "sélection",
    "sélections"
  ],
  "session break": [
    null,
    "en pause"
  ],
  "sudden death": [
    null,
    "mort subite"
  ],
  "text format": [
    null,
    "format texte"
  ],
  "the 2nd quarter will begin": [
    null,
    "le 2e quart-temps va débuter"
  ],
  "the 2nd set will begin": [
    null,
    "le 2e set va débuter"
  ],
  "the 3rd quarter will begin": [
    null,
    "le 3e quart-temps va débuter"
  ],
  "the 3rd set will begin": [
    null,
    "le 3e set va débuter"
  ],
  "the 4th quarter will begin": [
    null,
    "le 4e quart-temps va débuter"
  ],
  "the 4th set will begin": [
    null,
    "le 4e set va débuter"
  ],
  "the 5th set will begin": [
    null,
    "le 5e set va débuter"
  ],
  "timer:d": [
    null,
    "j"
  ],
  "timer:finished": [
    null,
    "Terminé"
  ],
  "timer:h": [
    null,
    "h"
  ],
  "timer:min": [
    null,
    "min"
  ],
  "up to": [
    null,
    "jusqu'à"
  ],
  "walkover": [
    null,
    "forfait"
  ],
  "with your next deposit": [
    null,
    "sur ton premier dépôt"
  ]
}
  }
}
